import React from "react";
import Header from "../../Components/Header";
import Feature from "../../Components/Feature";
import Footer from "../../Components/Footer";
import UserLeftSidebar from "../Components/UserLeftSidebar";
import DashboardRight from "../Layouts/DashboardRight";



export default function Dashboard() {
  return (
    <div>
      <Header mode="dark" />

      <div className="container-fluid">
        <div className="dashboard-full-page">
      
      <UserLeftSidebar />

      <DashboardRight />

       </div>
      </div>


      <Feature />
      <Footer />
    </div>
  );
}
